import React from "react";
import {
  Box,
  Typography,
  Grid,
  //   TableSelectRow,
} from "@mui/material";

interface ConfusionMatrixProps {
  statusCMImg: boolean | null;
  statusRImg: boolean | null;
  statusPCImg: boolean | null;
  statusRCImg: boolean | null;
  LoaderGIF: string;
  modelType: string | null;
  currentConfusisonMetrixPNG: string;
  currentResultPNG: string;
  currentPCurvePNG: string;
  currentRCurvePNG: string;
  boxHeight: string;
}
const confusionMatrix: React.FC<ConfusionMatrixProps> = ({
  statusCMImg,
  statusRImg,
  statusPCImg,
  statusRCImg,
  LoaderGIF,
  modelType,
  currentConfusisonMetrixPNG,
  currentResultPNG,
  currentPCurvePNG,
  currentRCurvePNG,
  boxHeight,
}) => {
  return (
    <>
      <Box
        sx={{
          marginTop: "20px",
          background: "white",
          borderRadius: "6px",
          overflow: "auto",
          padding: "20px", // Add padding for spacing
          flexWrap: "wrap",
          height: `calc(100vh - ${boxHeight}px)`,
        }}
      >
        {/* Confusion Matrix Section */}
        {statusCMImg === null &&
          statusRImg === null &&
          statusPCImg === null &&
          statusRCImg === null && (
            <Box
              component="img"
              src={LoaderGIF} // Replace with your image URL
              alt="Confusion Matrix"
              sx={{
                display: "block", // Ensures the image is treated as a block-level element
                margin: "0 auto", // Horizontally centers the image
                textAlign: "center", // Aligns the box content
                maxWidth: "100%", // Ensures the image is responsive
                height: "auto", // Maintains aspect ratio
              }}
            />
          )}
{(modelType === "Object Detection"
  ? (!statusCMImg &&
      statusCMImg !== null &&
      !statusRImg &&
      statusRImg !== null &&
      !statusPCImg &&
      statusPCImg !== null &&
      !statusRCImg &&
      statusRCImg !== null)
  : (!statusCMImg &&
      statusCMImg !== null &&
      !statusRImg &&
      statusRImg !== null)) && (
            <Box
              sx={{
                textAlign: "center",
                alignContent: "center",
              }}
            >
              There is no result for this model.
            </Box>
          )}

        {statusCMImg ? (
          <Box
            sx={{
              marginBottom: "40px", // Add spacing between sections
            }}
          >
            <Grid container spacing={0}>
              {/* Title and Description - Sticky at Top */}
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  position: "sticky",
                  top: "1px", // Stays at the top while scrolling
                  alignSelf: "flex-start", // Ensures it doesn’t stretch
                  backgroundColor: "white", // Prevents content overlap
                  paddingTop: "1px",
                  //zIndex: 10,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Confusion Matrix
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Shows correct and incorrect classifications, highlighting
                  model performance per class.
                </Typography>
              </Grid>

              {/* Sticky Image - Stays Visible */}
              <Grid item xs={12} md={8}>
                <Box
                  onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    if (currentConfusisonMetrixPNG) {
                      window.open(currentConfusisonMetrixPNG, "_blank");
                    }
                  }}
                  component="img"
                  src={currentConfusisonMetrixPNG}
                  alt="Confusion Matrix"
                  sx={{
                    width:
                      currentConfusisonMetrixPNG === LoaderGIF
                        ? "20px"
                        : "100%",
                    height: "auto",
                    borderRadius: 2,
                    boxShadow: 3,
                    cursor: "pointer",
                    position: "sticky",
                    top: "20px", // Keeps image at top of the container
                    zIndex: 5,
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        ) : (
          ""
        )}

        {/* Results Section */}
        {statusRImg ? (
          <Box
            sx={{
              marginBottom: "40px", // Add spacing between sections
            }}
          >
            <Grid container spacing={4} alignItems="center">
              {/* Title and Description */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Results
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Displays loss (box, class, DFL) and metrics (precision,
                  recall, mAP50, mAP50-95) trends to assess model training and
                  performance.
                </Typography>
              </Grid>

              {/* Responsive Image */}
              <Grid item xs={12}>
                <Box
                  onClick={(event) => {
                    event.stopPropagation(); // Prevents the table cell click from being triggered
                    event.preventDefault(); // Prevents default behavior
                    if (currentResultPNG) {
                      window.open(currentResultPNG, "_blank"); // Open image in a new tab
                    }
                  }}
                  component="img"
                  src={currentResultPNG} // Replace with your image URL
                  alt="Results"
                  sx={{
                    width: currentResultPNG === LoaderGIF ? "20px" : "100%",
                    height: "auto",
                    borderRadius: 2,
                    boxShadow: 3,
                    cursor: "pointer",
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        ) : (
          ""
        )}
        {/* Precision Curve Section */}
        {statusPCImg && (
          <Box
            sx={{
              marginBottom: "40px", // Add spacing between sections
            }}
          >
            <Grid container spacing={0} alignItems="center">
              {/* Title and Description */}
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  position: "sticky",
                  top: "1px", // Stays at the top while scrolling
                  alignSelf: "flex-start", // Ensures it doesn’t stretch
                  backgroundColor: "white", // Prevents content overlap
                  paddingTop: "1px",
                  //zIndex: 10,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Precision Curve
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Tracks precision (true positives out of predicted positives)
                  over epochs.
                </Typography>
              </Grid>

              {/* Responsive Image */}
              <Grid item xs={12} md={8}>
                <Box
                  onClick={(event) => {
                    event.stopPropagation(); // Prevents the table cell click from being triggered
                    event.preventDefault(); // Prevents default behavior
                    if (currentPCurvePNG) {
                      window.open(currentPCurvePNG, "_blank"); // Open image in a new tab
                    }
                  }}
                  component="img"
                  src={currentPCurvePNG} // Replace with your image URL
                  alt="Confusion Matrix"
                  sx={{
                    width: currentPCurvePNG === LoaderGIF ? "20px" : "100%",
                    height: "auto",
                    borderRadius: 2,
                    boxShadow: 3,
                    cursor: "pointer",
                    position: "sticky",
                    top: "20px", // Keeps image at top of the container
                    zIndex: 5,
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        )}
        {statusRCImg && (
          <Box
            sx={{
              marginBottom: "40px", // Add spacing between sections
            }}
          >
            <Grid container spacing={0} alignItems="center">
              {/* Responsive Image */}
              <Grid item xs={12} md={8}>
                <Box
                  onClick={(event) => {
                    event.stopPropagation(); // Prevents the table cell click from being triggered
                    event.preventDefault(); // Prevents default behavior
                    if (currentRCurvePNG) {
                      window.open(currentRCurvePNG, "_blank"); // Open image in a new tab
                    }
                  }}
                  component="img"
                  src={currentRCurvePNG} // Replace with your image URL
                  alt="Confusion Matrix"
                  sx={{
                    width: currentRCurvePNG === LoaderGIF ? "20px" : "100%",
                    height: "auto",
                    borderRadius: 2,
                    boxShadow: 3,
                    cursor: "pointer",
                    position: "sticky",
                    top: "20px", // Keeps image at top of the container
                    zIndex: 5,
                  }}
                />
              </Grid>

              {/* Title and Description */}
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  position: "sticky",
                  top: "20px", // Stays at the top while scrolling
                  alignSelf: "flex-start", // Ensures it doesn’t stretch
                  backgroundColor: "white", // Prevents content overlap
                  paddingLeft: "10px",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Recall Curve
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Tracks recall (true positives out of actual positives) over
                  epochs.
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </>
  );
};

export default confusionMatrix;
